import { c as _c } from "react/compiler-runtime";
import { Button } from '@systemeio/components';
import { PlusIcon } from '@systemeio/icons';
import { useAddFunnelStep } from 'modules/funnels/funnel/hooks/use-add-funnel-step';
import { useUpdateFunnelStepQuery } from 'modules/funnels/funnel/hooks/use-update-funnel-step-query';
import { CreateFunnelStepErrorsInterface, CreateFunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { getFunnelStepPageTypeDataOptions } from 'modules/funnels/funnel/utils/get-funnel-step-page-type-data-options';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { FormInput, FormSelectWithGroups, RadioGroup, type RadioGroupOption } from 'shared/components';
import CreateModal from 'shared/components/create-modal';
import { FunnelGroupEnum, funnelGroupTitleLocoKeys, FunnelStepSourceEnum, funnelStepSourceLocoKeys } from 'shared/enums/funnel-step-type-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { fetchWithFieldErrors } from 'shared/utils/fetch-with-errors';
import { useFunnelStepsList } from '../hooks/use-funnel-steps-list';
const defaultValues: CreateFunnelStepInterface = {
  name: '',
  type: undefined,
  funnelStepSource: FunnelStepSourceEnum.ChooseTemplate
};
const defaultErrors: CreateFunnelStepErrorsInterface = {
  fields: {
    name: '',
    type: ''
  }
};
interface Props {
  buttonProps?: Button.Props;
}
function CreateFunnelStepModal(t0) {
  const $ = _c(55);
  const {
    buttonProps
  } = t0;
  const router = useRouter();
  const {
    t
  } = useLocoTranslation();
  const funnelId = parseInt(router.query.funnelId as string) as FunnelId;
  const {
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  const [errors, setErrors] = useState(defaultErrors);
  const [opened, setOpened] = useState(false);
  const {
    updateFunnelStepQuery
  } = useUpdateFunnelStepQuery();
  const {
    addFunnelStep
  } = useAddFunnelStep();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpened(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onClose = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setErrors(defaultErrors);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const afterLeave = t2;
  let t3;
  if ($[2] !== addFunnelStep || $[3] !== funnelId || $[4] !== mutateFunnelStepsList || $[5] !== updateFunnelStepQuery) {
    t3 = async data => {
      await fetchWithFieldErrors(async () => {
        const responseData = await addFunnelStep(Number(funnelId), data);
        await mutateFunnelStepsList(data_0 => {
          if (data_0) {
            return [...data_0, responseData];
          }
        }, false);
        updateFunnelStepQuery(responseData.id);
        onClose();
      }, setErrors);
    };
    $[2] = addFunnelStep;
    $[3] = funnelId;
    $[4] = mutateFunnelStepsList;
    $[5] = updateFunnelStepQuery;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleCreate = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = Object.values(FunnelGroupEnum);
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t4.map(key => ({
      id: key,
      caption: t(funnelGroupTitleLocoKeys[key])
    }));
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const funnelStepTypeGroupsData = t5;
  let t6;
  if ($[10] !== t) {
    t6 = t(funnelStepSourceLocoKeys[FunnelStepSourceEnum.ChooseTemplate]);
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = {
      id: FunnelStepSourceEnum.ChooseTemplate,
      caption: t6
    };
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t(funnelStepSourceLocoKeys[FunnelStepSourceEnum.StartFromScratch]);
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = {
      id: FunnelStepSourceEnum.StartFromScratch,
      caption: t8
    };
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t9) {
    t10 = [t7, t9];
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const funnelStepSourceData = t10;
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setOpened(true);
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <PlusIcon />;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t) {
    t13 = t("dashboard.funnel.create_funnel_step");
    $[23] = t;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13) {
    t14 = <span>{t13}</span>;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== buttonProps || $[28] !== t14) {
    t15 = <Button onClick={t11} data-test-element="create-funnel-step-button" size="sm" variant="ghost-color" {...buttonProps}>{t12}{t14}</Button>;
    $[27] = buttonProps;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t) {
    t16 = t("dashboard.funnel.funnel_step");
    $[30] = t;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== errors || $[33] !== t) {
    t17 = {
      field: "name",
      onRender: (value, onChange) => <FormInput key="funnel-step-name" label={t("global.name")} value={value} onChange={e => onChange(e.target.value)} error={errors.fields.name} data-test-element="create-funnel-step-name-field" required={true} />
    };
    $[32] = errors;
    $[33] = t;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== errors || $[36] !== funnelStepTypeGroupsData || $[37] !== t) {
    t18 = {
      field: "type",
      onRender: (value_0, onChange_0) => <FormSelectWithGroups key="funnel-step-type" data={getFunnelStepPageTypeDataOptions(t)} label={t("global.type")} value={value_0} onChange={value_1 => onChange_0(value_1)} placeholder={t("dashboard.funnel.funnel_step_type_placeholder")} error={errors.fields.type} dataTest={{
        "data-test-element": "create-funnel-step-type-field"
      }} groups={funnelStepTypeGroupsData} required={true} withoutCloseIcon={true} />
    };
    $[35] = errors;
    $[36] = funnelStepTypeGroupsData;
    $[37] = t;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== funnelStepSourceData || $[40] !== t) {
    t19 = {
      field: "funnelStepSource",
      onRender: (value_2, onChange_1) => <RadioGroup ariaLabel={`${t("dashboard.funnel.funnel_step_source_choose_template")} / ${t("dashboard.funnel.funnel_step_source_start_from_scratch")}`} selected={value_2} options={funnelStepSourceData} onChange={value_3 => onChange_1(value_3)} />
    };
    $[39] = funnelStepSourceData;
    $[40] = t;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t17 || $[43] !== t18 || $[44] !== t19) {
    t20 = [t17, t18, t19];
    $[42] = t17;
    $[43] = t18;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = ["name", "type"];
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== handleCreate || $[48] !== opened || $[49] !== t16 || $[50] !== t20) {
    t22 = <CreateModal opened={opened} onClose={onClose} afterLeave={afterLeave} defaultValues={defaultValues} caption={t16} saveDataAttribute="create-funnel-step-save-button" creatable={t20} onCreate={handleCreate} requiredFields={t21} />;
    $[47] = handleCreate;
    $[48] = opened;
    $[49] = t16;
    $[50] = t20;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t15 || $[53] !== t22) {
    t23 = <>{t15}{t22}</>;
    $[52] = t15;
    $[53] = t22;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  return t23;
}
export default CreateFunnelStepModal;